import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

type ListsContextType = {
  cityList: string[];
  jobList: string[];
  sectorList: string[];
};

type ListsContextProps = {
  cityList: string[];
  jobList: string[];
  sectorList: string[];
};

const ListsContext = createContext<ListsContextType>({ cityList: [], jobList: [], sectorList: [] });

export const ListsContextProvider = ({
  children,
  cityList,
  jobList,
  sectorList,
}: PropsWithChildren<ListsContextProps>) => {
  const value = useMemo(() => ({ cityList, jobList, sectorList }), [cityList, jobList, sectorList]);

  return <ListsContext.Provider value={value}>{children}</ListsContext.Provider>;
};

export const useListsContext = () => useContext(ListsContext);
